module.exports = __webpack_public_path__ + "img/box1.6ae69885.jpg";